import React, { useEffect } from "react";
import "./styles.css";


export const PoliciesAndConditions = () => {

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);

      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]); 
  
  return (
    <div
      className="container_PoliciesAndConditions"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className="containe_texts_PoliciesAndConditions"
        style={{
          maxWidth: 900,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex", 
            flexDirection: "column",
          }}

          id="policiesAndConditions"
        >
          <h1>TÉRMINOS Y CONDICIONES</h1>
          <p>
            TUVIAJEAPP.CO es un dominio de Internet y marca registrada ante la
            Superintendencia de Industria y Comercio de la República de Colombia, cuya
            titularidad corresponde a TUVIAJE AGENCIA DE VIAJES Y OPERADOR
            TURÍSTICO S.A.S, sociedad comercial legalmente constituida bajo las leyes
            colombianas.
          </p>
          <p>
            Por medio del presente documento, se establecen los términos y condiciones
            generales que el USUARIO DIGITAL debe tener en cuenta y que son aplicados
            por TUVIAJE en el sitio en internet TUVIAJEAPP.CO
          </p>
          <p>
            El ingreso, consulta y/o utilización de parte del USUARIO DIGITAL del sitio en
            internet TUVIAJEAPP.CO o de sus aplicaciones, implica su ACEPTACIÓN
            EXPRESA de todas y cada una de las siguientes condiciones.
          </p>
          <h2>TÉRMINOS Y CONDICIONES GENERALES DE USO DEL PORTAL WEB</h2>
          <p>
            1. El USUARIO DIGITAL, declara que es mayor de edad (mayor de 18 años) y
            dispone de la capacidad legal necesaria para contratar los destinos ofertados en
            la web TUVIAJEAPP.CO, así mismo, acepta y entiende la totalidad de las
            condiciones aquí enunciadas para utilizar esta web y contratar los servicios
            ofertados, como objeto vinculante a este acuerdo.
          </p>
          <p>
            2. Para el acceso al sitio web, el USUARIO DIGITAL debe contar con acceso a
            internet, computador personal, teléfono inteligente, tableta o cualquier otro
            dispositivo que permita acceder al sitio en internet. TUVIAJE no tiene
            responsabilidad alguna en daños o desperfectos que ocurran en los dispositivos
            que utilice el USUARIO DIGITAL para acceder al sitio en internet, ni asume valor
            alguno por los costos de conexión a internet.
          </p>
          <p>
            3. Todos los contenidos, marcas, logos, dibujos y demás distintivos gráficos,
            auditivos, electrónicos, slogan y similares que figuran en la página web de
            TUVIAJEAPP.CO, se hallan protegidos por los derechos de propiedad intelectual
            (Derechos de Autor y Propiedad Industrial) que son expresamente reservados por
            TUVIAJE o, en su caso, por las personas o empresas que figuran como autores o
            titulares de los derechos. La violación de los anteriores derechos será perseguida
            de conformidad con la legislación vigente.
          </p>
          <p>
            Por lo tanto, queda prohibida la reproducción, explotación, alteración,
            distribución o comunicación pública por cualquier título o medio de la totalidad
            de los contenidos de la página web TUVIAJEAPP.CO para usos diferentes de la
            legítima información o contratación por los USUARIO DIGITALES de los servicios
            ofertados. En todo caso, será necesario el consentimiento previo y por escrito de
            TUVIAJE.
          </p>
          <p>
            4. Los links o enlaces con otras páginas web, que aparezcan en las páginas del
            sitio WEB TUVIAJEAPP.CO, se ofrecen a efectos meramente informativos al
            USUARIO DIGITAL, por lo que TUVIAJE no se responsabiliza sobre los
            productos, servicios o contenidos que se oferten o suministren en las páginas de
            destino ubicados en otro dominio.
          </p>
          <p>
            5. TUVIAJE hace todos los esfuerzos necesarios dentro de sus medios para
            ofrecer la información contenida en el sitio en internet de forma veraz y sin
            errores tipográficos. En caso que en algún momento se produjera algún error de
            este tipo, ajeno en todo momento a la voluntad de TUVIAJE, se procederá a su
            corrección. De existir un error tipográfico en alguno de los precios mostrados y
            algún USUARIO DIGITAL hubiera tomado la decisión de compra basándose en
            dicho error, TUVIAJE se lo comunicará al USUARIO DIGITAL lo más pronto
            posible y la compra se rescindirá sin ningún costo por su parte, o le ofrecerá la
            oportunidad de mantener su reserva con el precio comercial correcto.
          </p>
          <p>
            6. Nuestro sitio en internet utiliza servidores publicitarios con el fin de facilitar
            contenidos publicitarios que el USUARIO DIGITAL visualiza en nuestras páginas.
            Dichos servidores publicitarios utilizan cookies que le permiten adaptar los
            contenidos publicitarios a los perfiles demográficos de los USUARIO DIGITALES.
            En ningún caso se obtienen datos personales a través de estas cookies.
          </p>
          <p>
            7. Al haber efectuado la reserva el USUARIO DIGITAL acepta expresamente que
            conoce todas y cada una de las condiciones indicadas en la presente página y en
            la correspondiente a cada una de las páginas escogidas.
          </p>
          <h2>CONDICIONES ESPECIALES Y RESPONSABILIDADES</h2>
          <p>
            1. Este sitio en internet que pertenece a TUVIAJE AGENCIA DE VIAJES Y
            OPERADOR TURÍSTICO S.A.S., declara que actúa como intermediario entre las
            personas (en adelante USUARIO DIGITAL) y las sociedades, entidades
            prestadoras del servicio de transporte especial, turísticos o de cualquier otro
            ofertado a través del sitio en internet.
          </p>
          <p>
            TUVIAJE AGENCIA DE VIAJES Y OPERADOR TURÍSTICO S.A.S no presta
            servicios de transporte, alojamiento ni complementarios. En este sentido, nos
            comprometemos únicamente a cumplir con los servicios de intermediación
            mencionados, con las salvedades especificadas en estos Términos y Condiciones,
            por lo que TUVIAJE no se responsabiliza por el incumplimiento total, parcial o
            defectuoso de los servicios ofertados a través de este sitio en internet a cargo de
            los prestadores de estos, ni por imprevistos ocasionados por asuntos o hechos de
            fuerza mayor, caso fortuito o eventos tales como modificaciones unilaterales,
            huelgas, condiciones climáticas, atrasos, cierres de vías causados por la
            autoridad o por terceros, terremotos, asuntos de salubridad, condiciones de
            seguridad, factores políticos, negación de permisos de ingreso, retiro del viajero
            por conductas que atenten contra la realización del viaje, ni como por los
            perjuicios materiales, personales o morales que pueda sufrir el pasajero por
            pérdida, daño o hurto de equipaje, ni por accidentes, enfermedades o
            fallecimientos, enunciados a vía de ejemplo. De todo ello, o cualquier otro que le
            origine discrepancia al USUARIO DIGITAL, si así lo desea, deberá reclamar
            directamente ante las empresas o entidades que hacen oferta de servicios a
            través de esta plataforma. No obstante, TUVIAJE colaborará al USUARIO
            DIGITAL en cuanto le sea posible.
          </p>

          <p>
            <b>2.</b> Cada servicio publicado en el sitio en internet señala las condiciones de
            prestación a cargo de cada operador, forma de pago y plazo. Respecto a servicios
            complementarios, visitas, espectáculos, conciertos, eventos deportivos y/o
            culturales, las condiciones de prestación de tales servicios, valor, forma de pago
            y plazo se sujetan a las condiciones del organizador de estos.
          </p>
          <p>
            <b>3.</b> El USUARIO DIGITAL es el único responsable de la custodia de su equipaje y
            documentos de viaje. TUVIAJE le informará al pasajero las restricciones de
            piezas y/o pesos aplicables por el transportador, siempre y cuando sean
            previamente publicadas por estos, siendo responsabilidad del pasajero acatarlas.
          </p>
          <p>
            <b>4.</b> Las condiciones de las reservas de viajes terrestres en transporte especial,
            están descritas en las Condiciones Generales para viajes.
          </p>
          <p>
            <b>5.</b> La inscripción como USUARIO DIGITAL registrado de TUVIAJEAPP.CO implica
            el conocimiento y aceptación expresa de las presentes condiciones generales y de
            las condiciones particulares determinadas para cada servicio. La contratación de
            un servicio turístico concreto ofertado por los proveedores de servicios o viajes
            combinados que figuran en TUVIAJEAPP.CO, implica la aceptación explícita de
            las condiciones generales de contratación del proveedor del que se trate.
          </p>
          <p>
            El documento en el que se formalice el contrato será archivado en una base de
            datos accesible únicamente a TUVIAJE, como responsable de la misma. El
            USUARIO DIGITAL podrá identificar y corregir los errores cometidos en la
            introducción de datos comunicando a TUVIAJE tal circunstancia.
          </p>

          <h5>CONDICIONES DE LAS OFERTAS CON PAGO ONLINE</h5>

          <p>
            <b>1.</b> Todos los precios y tarifas presentadas en la web de TUVIAJE, están sujetos a
            disponibilidad, cambios y vigencia sin previo aviso. Aplican restricciones y
            condiciones para cada tarifa publicada según su vigencia y demás
            particularidades de la oferta.
          </p>
          <p>
            <b>2.</b> Las ofertas presentes en TUVIAJEAPP.CO se confirman con número de tiquete
            y reserva de cupo una vez el usuario haya realizado el pago. En caso de que
            cuando se realice el pago no queden sillas disponibles en el bus que seleccionó el
            usuario el equipo de TUVIAJE procederá a comunicarse con el cliente para
            ofrecerle otra alternativa o su respectivo reembolso.
          </p>
          <p>
            <b>3.</b> Cuando se pretenda modificar la reserva, presente, pasada o futura y ésta
            haya sido confirmada, TUVIAJEAPP.CO cobrará los respectivos gastos de gestión
            equivalentes. La modificación será comunicada por e-mail
            (comercial@tuviajeapp.co) al prestador de servicio correspondiente, con 5 días
            hábiles de antelación a la fecha de viaje. También se entiende como modificación
            el cambio de nombre del cliente y la modificación de las fechas del viaje. De igual
            manera, las cancelaciones supondrán unos gastos de gestión de TUVIAJE.
          </p>
          <p>
            <b>4.</b> En sistemas de reservas las empresas de transporte no se pueda generar el pasaje,
            TUVIAJE procederá a hacer el respectivo reembolso siguiendo el proceso de
            reembolso establecido, de acuerdo al medio de pago empleado para la compra del
            viaje.
          </p>
          <p>
            <b>5.</b> El usuario digital declara que conoce y acepta en su integridad estas
            condiciones, las cuales constituyen el acuerdo único, total y excluyente de
            cualquier pacto o disposición legal en contrario, acerca de los términos,
            condiciones y restricciones de los servicios contratados.
          </p>
          <p>
            Al usar nuestro sitio de internet, como cualquier otro sitio que facilite
            transacciones en línea, EL USUARIO DIGITAL debe tener en cuenta lo siguiente:
          </p>
          <p>
            <b>Phishing:</b> Es posible que cualquier persona sea engañada, principalmente a
            través de correos electrónicos fraudulentos, para visitar un sitio falso con
            apariencia similar al nuestro, por medio del cual se obtiene información de la
            tarjeta débito o crédito para ser cargada en el sitio falso o en otro distinto. Por
            ello, recomendamos efectuar sus transacciones directamente en el dominio
            digitado en el navegador de su computador o celular.
          </p>
          <p>
            <b>Malware, spyware:</b> Es posible que en el computador, celular o dispositivo
            mediante el cual EL USUARIO DIGITAL realiza la transacción, tenga instalado
            sin conocimiento previo, algún software espía o mal intencionado que capture
            todo lo digitado por el teclado o capture información de dispositivos de entrada y
            sean enviados a alguna red o host en internet. Por ello recomendamos realizar
            las transacciones en equipos conocidos o seguros, que cuenten con programas
            antivirus o antimalware debidamente actualizados.
          </p>

          <h5>LEY APLICABLE</h5>
          <p><b>1.</b> Los presentes Términos y Condiciones son regidos por las normas del ordenamiento civil mercantil y demás leyes y normas aplicables incluyendo el uso y la costumbre.</p>
          <p><b>2.</b> El USUARIO DIGITAL acepta que la legislación aplicable al funcionamiento de este servicio es la colombiana. Serán competentes para conocer de las divergencias que se deriven de la interpretación o aplicación de este clausulado los Jueces y Tribunales del domicilio del USUARIO DIGITAL. TUVIAJE se reserva el derecho a realizar los cambios que considere oportunos en los términos y condiciones establecidos. Las modificaciones se incluirán de forma destacada en la página web TUVIAJEAPP.CO</p>
          <p><b>3.</b> Si cualquier cláusula incluida en estas condiciones generales fuese declarada, total o parcialmente, nula o ineficaz, tal nulidad o ineficacia afectará tan sólo a dicha disposición o a la parte de la misma que resulte nula o ineficaz, subsistiendo las condiciones generales en todo lo demás, teniéndose tal disposición, o la parte de la misma que resultase afectada, por no puesta.</p>

          <h5>TÉRMINOS Y CONDICIONES DE FACTURACIÓN</h5>
          <p>El USUARIO DIGITAL declara aceptar la factura emitida por las transacciones en la página en las ocasiones en que el tipo de producto y de pago genere para TUVIAJE la obligación legal de emitirlas. La factura estará a disposición del USUARIO DIGITAL en las oficinas de TUVIAJE, dirección: Calle 83c #17-52 Cali, Colombia, a partir del día hábil siguiente a aquel en que se realice la transacción, a través de los mecanismos electrónicos o digitales que disponga TUVIAJE.</p>

          <h5>TÉRMINOS Y CONDICIONES DE MANEJO DE DATOS PERSONALES</h5>
          <p><b>1.</b> EL USUARIO DIGITAL, para poder contratar servicios contenidos en TUVIAJEAPP.CO, deberá registrarse como USUARIO DIGITAL, a cuyos efectos declara que toda la información suministrada a la hora de registrarse es verdadera, completa y precisa. Así mismo, autoriza expresamente a TUVIAJE AGENCIA DE VIAJES Y OPERADOR TURÍSTICO S.A.S., de conformidad con las leyes de la República de Colombia, para que proceda a incluir en un sistema automatizado los datos de carácter personal que figuran en los campos del formulario por resultar necesarios para la adecuada prestación de sus servicios. Se indica que el Responsable de la información suministrada es la sociedad Digital TUVIAJE AGENCIA DE VIAJES Y OPERADOR TURÍSTICO S.A.S. Dirección Calle 83c # 17 - 52 Cali, Colombia, a efectos del ejercicio de los derechos de acceso, rectificación, cancelación y oposición previstos en la Ley. Del mismo modo, el USUARIO DIGITAL autoriza expresamente la comunicación de dichos datos a terceros cuando resulten necesarios para la adecuada prestación de los servicios que se contraten respetando en todo momento la legislación en vigor.</p>
          <p><b>2.</b> El USUARIO DIGITAL da su consentimiento expreso para recibir comunicaciones electrónicas con publicidad y novedades comerciales de TUVIAJE y de los productos o servicios que comercializa o promociona. TUVIAJE pone a disposición del USUARIO DIGITAL los medios de contacto referidos en el párrafo anterior para que estos revoquen su consentimiento.</p>
          <p><b>3.</b> El envío y la remisión de datos que se realice por el USUARIO DIGITAL a través de la página web TUVIAJEAPP.CO o la información que TUVIAJE remita, se encuentra protegida por las más modernas técnicas de seguridad electrónica en la red. Así mismo, los datos suministrados y almacenados en nuestras bases de datos se encuentran igualmente protegidos por sistemas de seguridad que impiden el acceso de terceros no autorizados a los mismos. TUVIAJE realiza sus mejores esfuerzos para disponer de los procedimientos más actualizados para la eficacia de los sistemas de seguridad.</p>
          <p><b>4.</b> El USUARIO DIGITAL es responsable de facilitar sus datos correctos, especialmente la dirección de entrega de los pedidos y documentos, así como los nombres de los pasajeros que deben coincidir exactamente con los que aparecen en su documento de identificación o Pasaporte. TUVIAJE no se hace responsable de los problemas o gastos generados por errores de esta índole.</p>
          <p><b>5.</b> En los casos en que sea legalmente aplicable y la creación y naturaleza de la información contenida en las bases de datos así lo exija, TUVIAJE AGENCIA DE VIAJES Y OPERADOR TURÍSTICO S.A.S. se encuentra sujeto a las normas y preceptos contenidos en la ley estatutaria 1266 de 2008 (Habeas Data) y demás normas en la materia.</p>

          <h5>POLÍTICA DE PRIVACIDAD</h5>
          <h6>INFORMACIÓN Y DATOS PERSONALES REGISTRADOS</h6>
          <p>Los datos personales que se registran son los siguientes, entre otros:</p>
          <ol>
            <li>Nombre y apellidos.</li>
            <li>Correo electrónico.</li>
            <li>Género.</li>
            <li>Teléfono de contacto.</li>
            <li>Dirección.</li>
            <li>Información de tarjeta(s) de crédito (número, entidad bancaria, fecha de vencimiento, código de seguridad).</li>
            <li>Datos personales del titular de la tarjeta (nombres y apellidos, tipo y número de identificación).</li>
            <li>Información del domicilio donde el titular de la tarjeta recibe sus extractos bancarios.</li>
            <li>Información necesaria para facilitar el viaje u otros servicios, incluyendo el nombre de acompañante(s) de viaje, contactos para casos de accidente o cualquier otra contingencia, preferencia en asientos o requerimientos médicos.</li>
            <li>Información y datos personales recolectados a través de encuestas, focus groups u otros métodos de investigación de mercado.</li>
            <li>
              Información requerida por los representantes de las áreas de ventas y/o de relaciones con el cliente con la finalidad de atender solicitudes o reclamos.
              En algunos casos, se podrá recolectar datos sensibles. Se informa a los titulares que no estarán obligados en ningún evento a autorizar el tratamiento de datos sensibles, y por lo tanto la prestación de nuestros servicios no está condicionada a la entrega de esta información sensible.
            </li>
          </ol>

          <h5>ALMACENAMIENTO Y FINALIDAD DEL TRATAMIENTO DE LOS DATOS PERSONALES</h5>

          <p>
            Todas las bases de datos de TuViaje están almacenados en un Data Center en la nube de operadores locales solo para efectos de almacenamiento, seguridad y control. Tú Viaje solo utiliza la información de clientes para transmitirla a los proveedores de los servicios contratados por el CLIENTE y no para cederla o comercializarla ante terceros no relacionados con estos servicios.
          </p>

          <p>
            La información suministrada permanecerá en el sistema de TuViaje por el término máximo necesario para permitirnos en el cumplimiento de las obligaciones legales y/o contractuales a nuestro cargo especialmente en materia contable, contractual, fiscal y tributaria o para atender las disposiciones aplicables a los aspectos administrativos, contables, fiscales, jurídicos e históricos de la información.
          </p>

          <p>
            Presumimos la veracidad de la información suministrada y no verificamos, ni asumimos la obligación de verificar la veracidad, vigencia, suficiencia y autenticidad de los datos que nos sean proporcionados. Por tanto, no asumimos responsabilidad por daños y/o perjuicios de toda naturaleza que pudieran tener origen en la falta de veracidad, vigencia, suficiencia o autenticidad de la información, incluyendo daños y perjuicios que puedan deberse a la homonimia o a la suplantación de la identidad. Si nos suministra información personal sobre una persona distinta a usted, como su cónyuge o un compañero de trabajo, entendemos que cuenta con la autorización de dicha persona para suministrarnos sus datos.
          </p>

          <p>
            Al inscribirse y/o navegar en nuestra página web, nuestros clientes y/o visitantes de la página manifiestan expresamente que conocen estas políticas y las aceptan, y otorgan su consentimiento para que se dé tratamiento a su información.
          </p>

          <h6>FINALIDAD QUE TIENE EL TRATAMIENTO DE LOS DATOS PERSONALES</h6>

          <p>
            Si el CLIENTE nos proporciona sus datos personales, nos autoriza para hacer uso de esta información para las finalidades señaladas en concordancia con lo previsto en esta Política de Privacidad, y NO procederemos a transferir o divulgar la misma fuera de nuestra plataforma salvo que:
          </p>

          <ol type="a">
            <li>Usted nos autorice a hacerlo.</li>
            <li>Sea necesario para permitir a nuestros contratistas, proveedores o agentes prestar los servicios que les hemos encomendado.</li>
            <li>La utilicemos nosotros o terceros para proporcionarle nuestros productos o servicios.</li>
            <li>Sea entregada a las entidades que prestan servicios de marketing en nuestro nombre o a otras entidades con las cuales tenemos acuerdos de mercadeo conjunto.</li>
            <li>Tenga relación con una fusión, consolidación, adquisición, desinversión u otro proceso de restructuración.</li>
            <li>Implementemos un contrato de transmisión de datos personales en los términos del Decreto 1377 de 2013.</li>
            <li>Según sea requerido o permitido por la ley o para las finalidades desarrolladas en la presente política de privacidad.</li>
          </ol>

          <p>
            Al aceptar esta Política de Privacidad, los titulares de los datos recolectados, autorizan que realicemos el tratamiento de los mismos, de forma parcial o total, incluyendo la recolección, almacenamiento, grabación, uso, circulación, procesamiento, supresión, transmisión y/o transferencia a terceros países de los datos suministrados, para la ejecución de las actividades relacionadas con los servicios y productos adquiridos, tales como, procesar, confirmar, cumplir y proveer los servicios y/o productos adquiridos, directamente y/o con la participación de terceros proveedores de productos o servicios así como para promocionar y publicitar nuestras actividades, productos y servicios, realizar transacciones, efectuar reportes a las distintas autoridades administrativas de control y vigilancia nacionales o internacionales, autoridades de policía o judiciales, entidades bancarias y/o compañías aseguradoras, para fines administrativos internos y/o comerciales tales como, investigación de mercados, auditorías, reportes contables, análisis estadísticos, realización de la reserva, modificaciones, reembolsos, atención de consultas, quejas y reclamos, pago de compensaciones e indemnizaciones, registros contables, correspondencia, procesamiento y verificación de tarjetas de crédito, débito y otros instrumentos de pago, identificación de fraudes y prevención de lavado de activos y de otras actividades delictivas y demás finalidades indicadas en este documento, entre otros.
          </p>


          <h5>SUMINISTRO DE DATOS A AUTORIDADES Y USOS ADICIONALES</h5>

          <p>
            En razón de nuestra actividad, estamos obligadas a suministrar una serie de datos de los CLIENTES a las autoridades que regulan el transporte público terrestre o entidades de seguridad nacionales, antes de la salida de los buses o en la llegada en cada ciudad de destino o en cualquier momento después de ejecutado el contrato de transporte. Por regla general, la información se refiere a los datos de identidad de los pasajeros que viajan a bordo así como los contenidos en sus respectivos documentos de viaje.
          </p>

          <p>
            Adicionalmente, nuestros clientes, en su calidad de titulares de los datos recolectados, al aceptar esta política de privacidad, nos autorizan para:
          </p>

          <ol>
            <li>Permitir el acceso a la información y datos personales a los auditores o terceros contratados para llevar a cabo procesos de auditoría interna o externa propios de la actividad comercial que desarrollamos.</li>
            <li>Utilizar la información recibida para fines de mercadeo de sus productos y servicios, y de los productos y servicios de terceros con los que tengamos una relación de negocios.</li>
            <li>Consultar y actualizar los datos personales, en cualquier tiempo, con el fin de mantener actualizada dicha información.</li>
            <li>Suministrar los datos personales a las autoridades de control y vigilancia de policía o judiciales, en virtud de un requerimiento legal o reglamentario y/o usar o revelar esta información y datos personales en defensa de sus derechos y/o su patrimonio en cuanto dicha defensa tenga relación con los productos y/o servicios contratados por sus clientes y consumidores.</li>
            <li>Contratar con terceros el almacenamiento y/o procesamiento de la información y datos personales para la correcta ejecución de los contratos celebrados con nosotros, bajo los estándares de seguridad y confidencialidad a los cuales estamos obligados.</li>
            <li>Recibir comunicaciones electrónicas con publicidad y novedades comerciales de TuViaje y de los productos o servicios que comercializa o promociona. TuViaje pone a disposición del CONSUMIDOR los medios de contacto referidos en el párrafo anterior para que estos revoquen su consentimiento.</li>
          </ol>

          <p>
            Los niños, niñas y adolescentes menores de edad, podrán ser CLIENTES de los productos y servicios que ofrecemos, siempre y cuando actúen a través de o debidamente autorizados por sus padres o por quienes tengan la patria potestad del menor. Velaremos por el uso adecuado de los datos personales de los niños, niñas y adolescentes menores de edad, garantizando que en el tratamiento de sus datos se respete el interés superior de ellos, y sus derechos fundamentales y en lo posible, teniendo en cuenta su opinión, como titulares de sus datos personales.
          </p>

          <p>
            Con la aceptación de la presente Política de Privacidad, los titulares de los datos personales nos autorizan para hacerles llegar por distintos medios y vías (incluyendo correo electrónico, SMS o mensajes de texto, etc.) información de productos y servicios, y de ofertas de productos y servicios que creemos pueden serle de interés.
          </p>

          <p>
            Nuestro sitio web utiliza servidores publicitarios con el fin de facilitar contenidos publicitarios que el CLIENTE visualiza en nuestro sitio web. Dichos servidores publicitarios utilizan cookies que le permiten adaptar los contenidos publicitarios a los perfiles demográficos de los CLIENTES y conocer la procedencia, actividades y preferencias de nuestros CLIENTES al navegar en la web, incrementar la funcionalidad y la accesibilidad de los sitios web, verificar que los clientes cumplan con los criterios requeridos para procesar sus solicitudes y para adaptar sus productos y servicios a las necesidades de los consumidores. Estas cookies pueden ser deshabilitadas y eliminadas cuando se desee. Para este efecto, puede consultar y/o solicitar la ayuda del navegador de Internet que utilice.
          </p>

          <h5>SEGURIDAD Y CONFIDENCIALIDAD CON TUVIAJE</h5>

          <p>
            El envío y la remisión de datos que se realice por el CLIENTE a través de la WEB TUVIAJE.CO o la información que TuViaje recolecte y haga tratamiento, se encuentra protegida por técnicas de seguridad electrónica en la red. Asimismo, los datos suministrados y almacenados en nuestra plataforma, se encuentran igualmente protegidos por sistemas de seguridad que impiden el acceso de terceros NO autorizados a los mismos. TuViaje realiza sus mejores esfuerzos para disponer de los procedimientos más actualizados para la eficacia de los sistemas de seguridad.
          </p>

          <p>
            En este sentido, bajo apoyo de herramientas tecnológicas de seguridad e implementamos prácticas de seguridad reconocidas en la industria, que incluyen: transmisión y almacenamiento de información sensible a través de mecanismos seguros, tales como cifrado, uso de protocolos seguros; aseguramiento de componentes tecnológicos, restricción de acceso a la información sólo a personal autorizado, respaldo de información, prácticas de desarrollo seguro de software, entre otros.
          </p>

          <p>
            Los terceros contratados por nosotros están igualmente obligados a adherirse y dar cumplimiento a las políticas y manuales de seguridad de la información, así como a los protocolos de seguridad que aplicamos a todos nuestros procesos. Todo contrato con terceros que involucre el tratamiento de información y datos personales, incluye un acuerdo de confidencialidad que detalla sus compromisos para la protección, cuidado, seguridad y preservación de la confidencialidad, integridad y privacidad de la misma.
          </p>

          <h5>DERECHOS DE LOS CLIENTES Y PROCEDIMIENTOS</h5>

          <p>
            Con la aceptación de los Términos y Condiciones de los cuales hace parte integral esta Política de Privacidad, usted manifiesta libre, expresa y previamente haber sido informado sobre los derechos que la ley le concede como titular de sus datos personales y que se enuncian a continuación:
          </p>

          <ol>
            <li>Conocer, actualizar y rectificar sus datos personales frente a la entidad responsable del tratamiento o encargada del tratamiento de sus datos personales.</li>
            <li>Solicitar prueba de la autorización otorgada al responsable del tratamiento salvo cuando expresamente se exceptúa como requisito para el tratamiento.</li>
            <li>Ser informado por el responsable del tratamiento o el encargado del tratamiento, previa solicitud, respecto del uso que le ha dado a los datos personales.</li>
            <li>Presentar ante la Superintendencia de Industria y Comercio quejas por infracciones al régimen de protección de datos personales.</li>
            <li>Revocar la autorización y/o solicitar la supresión del dato personal en los términos de la Ley 1581 de 2012.</li>
            <li>Acceder en forma gratuita una vez por mes a sus datos personales que hayan sido objeto de tratamiento, en los términos de la normatividad vigente.</li>
          </ol>

          <h6>CONSULTAS</h6>

          <p>
            Los titulares (las personas autorizadas o causahabientes) podrán consultar su información personal que repose en nuestra plataforma, caso en el cual les suministraremos la información solicitada, previa verificación de la legitimación para presentar dicha solicitud. La consulta será atendida en un término máximo de diez (10) días hábiles contados a partir de la fecha de recibo de la misma. Cuando no fuere posible atender la consulta dentro de dicho término, se le informarán los motivos de la demora, señalando la fecha en que se atenderá su consulta, la cual en ningún caso podrá superar los cinco (5) días hábiles siguientes al vencimiento del primer término.
          </p>

          <h6>RECLAMOS</h6>

          <p>
            Si los titulares, las personas autorizadas o los causahabientes consideran que la información contenida en nuestra plataforma debe ser objeto de corrección, actualización o supresión, o cuando adviertan el presunto incumplimiento de cualquiera de los deberes contenidos en la Regulación, podrán presentar un reclamo ante nosotros, el cual será tramitado bajo las siguientes reglas:
          </p>

          <ol>
            <li>
              Su reclamo deberá formularse mediante solicitud dirigida a TuViaje, con su identificación, la descripción de los hechos que dan lugar al reclamo, su dirección, y acompañando los documentos que se quiera hacer valer. Si el reclamo resulta incompleto, lo requerimos dentro de los cinco (5) días siguientes a la recepción del reclamo para que subsane las fallas. Transcurridos dos (2) meses desde la fecha del requerimiento, sin que usted presente la información requerida, entenderemos que ha desistido del reclamo. En caso de que no seamos competentes para resolver su reclamo, dará traslado a quien corresponda en un término máximo de dos (2) días hábiles y le informará oportunamente.
            </li>
            <li>
              De ser procedente, una vez recibido el reclamo completo, se incluirá en la base de datos una leyenda que diga "reclamo en trámite" y el motivo del mismo, en un término no mayor a dos (2) días hábiles. Dicha leyenda deberá mantenerse hasta que el reclamo sea decidido.
            </li>
            <li>
              El término máximo para atender el reclamo será de quince (15) días hábiles contados a partir del día siguiente a la fecha de su recibo. Cuando no fuere posible atender el reclamo dentro de dicho término, se le informarán los motivos de la demora y la fecha en que se atenderá su reclamo, la cual en ningún caso podrá superar los ocho (8) días hábiles siguientes al vencimiento del primer término.
            </li>
          </ol>

          <p>
            El área de atención de peticiones, consultas o reclamos ante la cual el titular de la información puede ejercer sus derechos es:
          </p>

          <p>
            <strong>ATENCION AL CLIENTE</strong><br />
            Teléfono: +57 304 4771614 - 3207203420.<br />
            Correo de contacto: <a href="mailto:protecciondedatos@tuviajeapp.co">protecciondedatos@tuviajeapp.co</a>
          </p>

          <h6>MODIFICACIONES Y VIGENCIA DE LA POLÍTICA DE PRIVACIDAD</h6>

          <p>
            Podremos modificar en cualquier momento los términos y condiciones de estas políticas de privacidad y confidencialidad y/o las prácticas de envío de e-mails. Si decidimos introducir algún cambio material a nuestras políticas de privacidad, se informará en la página web y publicando una versión actualizada de las políticas de privacidad. Las bases de datos tendrán vigencia indefinida, de conformidad con las finalidades y usos de la información.
          </p>

          <p><strong>Vigente y con actualización desde el 01 de junio de 2025.</strong></p>

        </div>


        <div id="privacy-policy">
          <h5>POLÍTICA DE PRIVACIDAD</h5>
          <p><strong>TUVIAJE AGENCIA DE VIAJES Y OPERADOR TURÍSTICO S.A.S.</strong></p>
          <p>Sitio web: <a href="https://www.tuviajeapp.co">www.tuviajeapp.co</a></p>
          <p>Vigente desde el 01 de junio de 2025</p>

          <h6>1. INTRODUCCIÓN</h6>
          <p>
            Esta Política de Privacidad describe cómo TUVIAJE AGENCIA DE VIAJES Y OPERADOR TURÍSTICO S.A.S., en adelante TUVIAJE, recolecta, usa, almacena, comparte y protege los datos personales de los USUARIOS DIGITALES que acceden, navegan o hacen uso del sitio web TUVIAJEAPP.CO y sus canales digitales asociados.
            El tratamiento de los datos personales se realiza en cumplimiento de la Ley 1581 de 2012, el Decreto 1377 de 2013, la Ley 1266 de 2008, las directrices de la Superintendencia de Industria y Comercio (SIC) y demás normas aplicables.
          </p>

          <h6>2. RESPONSABLE DEL TRATAMIENTO</h6>
          <p>Datos de contacto del responsable:</p>
          <ul>
            <li>Correo electrónico: <a href="mailto:protecciondedatos@tuviajeapp.co">protecciondedatos@tuviajeapp.co</a></li>
            <li>Dirección física: KR 83 C # 17 – 52</li>
            <li>Teléfono: 3112882131</li>
            <li>Sitio web: <a href="https://www.tuviajeapp.co">www.tuviajeapp.co</a></li>
          </ul>

          <h6>3. ALCANCE</h6>
          <p>
            Esta política aplica a todos los usuarios, clientes, proveedores, empleados, contratistas y visitantes que interactúan con los canales digitales, productos o servicios prestados por TUVIAJE.
          </p>

          <h6>4. DATOS PERSONALES RECOLECTADOS</h6>
          <p>TUVIAJE puede recolectar los siguientes datos:</p>
          <ul>
            <li>Identificación: nombre completo, tipo y número de documento.</li>
            <li>Contacto: dirección, correo electrónico, número de celular.</li>
            <li>Información transaccional: historial de reservas, métodos de pago, número de tarjeta (tokenizada o encriptada), información de facturación.</li>
            <li>Datos de viaje: fechas, destinos, preferencias de alojamiento, acompañantes.</li>
            <li>Datos técnicos: dirección IP, cookies, ubicación, navegador, tipo de dispositivo.</li>
            <li>Datos sensibles (cuando aplique): estado de salud, necesidades especiales, preferencias alimenticias, bajo consentimiento expreso.</li>
          </ul>

          <h6>5. FINALIDADES DEL TRATAMIENTO</h6>
          <p>Los datos personales recolectados serán tratados con las siguientes finalidades:</p>
          <ul>
            <li>Procesar reservas, compras de tiquetes, paquetes turísticos y otros servicios ofrecidos.</li>
            <li>Brindar asistencia y atención al cliente antes, durante y después del viaje.</li>
            <li>Enviar confirmaciones, recordatorios, novedades y notificaciones relacionadas con el servicio contratado.</li>
            <li>Compartir datos con aerolíneas, hoteles, operadores o terceros requeridos para prestar el servicio.</li>
            <li>Gestionar encuestas de satisfacción, programas de fidelización y contenido promocional.</li>
            <li>Realizar análisis estadísticos y estudios de mercado para mejorar la experiencia del usuario.</li>
            <li>Prevenir fraudes, validar identidad y cumplir con obligaciones legales.</li>
          </ul>

          <h6>6. TRATAMIENTO DE DATOS SENSIBLES</h6>
          <p>TUVIAJE sólo recolectará datos sensibles cuando:</p>
          <ul>
            <li>Sean estrictamente necesarios para la prestación del servicio (ej. estado de salud para seguros de viaje).</li>
            <li>El titular otorgue autorización explícita y por escrito.</li>
            <li>La ley lo permita o exija.</li>
          </ul>

          <h6>7. AUTORIZACIÓN DEL TITULAR</h6>
          <p>
            Al aceptar esta Política de Privacidad, el USUARIO otorga su consentimiento previo, informado y expreso para que TUVIAJE realice el tratamiento de sus datos personales conforme a las finalidades descritas. Esta autorización podrá darse por medios físicos, digitales, verbales o mediante conductas inequívocas, como el registro en la plataforma o el uso continuo del sitio.
          </p>

          <h6>8. TRANSFERENCIA Y TRANSMISIÓN DE DATOS</h6>
          <p>TUVIAJE podrá compartir los datos con:</p>
          <ul>
            <li>Operadores turísticos, aerolíneas, hoteles, aseguradoras y demás proveedores de servicios vinculados a la experiencia del usuario.</li>
            <li>Plataformas tecnológicas de terceros (pasarelas de pago, software de gestión, proveedores en la nube).</li>
            <li>Autoridades administrativas o judiciales, cuando sea requerido legalmente.</li>
          </ul>
          <p>
            Toda transferencia nacional o internacional será realizada conforme a los principios de confidencialidad, seguridad y legalidad.
          </p>

          <h6>9. PROTECCIÓN Y SEGURIDAD DE LA INFORMACIÓN</h6>
          <p>TUVIAJE implementa medidas de seguridad administrativas, técnicas y jurídicas para proteger los datos personales frente a accesos no autorizados, pérdida, destrucción o alteración. Estas incluyen:</p>
          <ul>
            <li>Cifrado de datos sensibles.</li>
            <li>Control de accesos.</li>
            <li>Monitoreo de servidores.</li>
            <li>Certificados SSL.</li>
            <li>Capacitación interna en protección de datos.</li>
          </ul>

          <h6>10. DERECHOS DEL TITULAR</h6>
          <p>Los titulares de los datos pueden ejercer los siguientes derechos:</p>
          <ul>
            <li>Acceder a sus datos personales.</li>
            <li>Solicitar actualización, corrección o supresión.</li>
            <li>Revocar la autorización otorgada.</li>
            <li>Solicitar prueba de la autorización.</li>
            <li>Ser informado sobre el uso dado a sus datos.</li>
          </ul>
          <p>Para ejercer estos derechos, el titular podrá enviar una solicitud a:</p>
          <ul>
            <li>Correo electrónico: <a href="mailto:protecciondedatos@tuviajeapp.co">protecciondedatos@tuviajeapp.co</a></li>
            <li>Dirección física: KR 83 C # 17 – 52</li>
            <li>Teléfono: 3112882131</li>
            <li>Sitio web: <a href="https://www.tuviajeapp.co">www.tuviajeapp.co</a></li>
          </ul>
          <p>TUVIAJE responderá dentro de los plazos legales: 10 días hábiles para consultas y 15 días hábiles para reclamos.</p>

          <h6>11. COOKIES Y TECNOLOGÍAS DE SEGUIMIENTO</h6>
          <p>El sitio web utiliza cookies propias y de terceros para:</p>
          <ul>
            <li>Reconocer la sesión del usuario.</li>
            <li>Personalizar la experiencia de navegación.</li>
            <li>Analizar el comportamiento de los usuarios en el sitio.</li>
            <li>Ofrecer publicidad personalizada.</li>
          </ul>
          <p>El usuario puede configurar su navegador para rechazar cookies, aunque esto puede afectar el uso de ciertas funciones del sitio.</p>

          <h6>12. MODIFICACIONES A LA POLÍTICA</h6>
          <p>
            TUVIAJE podrá modificar esta política en cualquier momento. Las modificaciones serán publicadas en el sitio web y se entenderán aceptadas si el titular continúa usando los servicios o no presenta oposición expresa.
          </p>

          <h6>13. LEY APLICABLE</h6>
          <p>
            Esta Política se rige por las leyes de la República de Colombia, en particular por la Ley 1581 de 2012, el Decreto 1377 de 2013, y demás normas que regulan la protección de datos personales.
          </p>

        </ div>

        <div id="data-protection-policy">
          <h5>POLÍTICA DE TRATAMIENTO DE LA INFORMACIÓN Y DATOS PERSONALES</h5>
          <p><strong>TUVIAJE S.A.S.</strong></p>
          <p>Vigente desde el 01 de junio de 2025</p>

          <h6>1. IDENTIFICACIÓN DEL RESPONSABLE</h6>
          <p>
            TUVIAJEAPP.CO es un dominio de Internet y marca registrada ante la
            Superintendencia de Industria y Comercio de la República de Colombia, cuya
            titularidad corresponde a TUVIAJE AGENCIA DE VIAJES Y OPERADOR TURÍSTICO
            S.A.S., sociedad comercial legalmente constituida bajo las leyes colombianas, con NIT N° 901354394-4 y domicilio principal en Carrera 83c#17-52, Cali, Colombia.
          </p>
          <p>Datos de contacto del responsable:</p>
          <ul>
            <li>Correo electrónico: <a href="mailto:protecciondedatos@tuviajeapp.co">protecciondedatos@tuviajeapp.co</a></li>
            <li>Dirección física: KR 83 C # 17 – 52</li>
            <li>Teléfono: 3112882131</li>
          </ul>

          <h6>2. ALCANCE</h6>
          <p>
            La presente política se aplica al tratamiento de los datos personales recolectados a través del sitio web <a href="https://www.tuviajeapp.co">www.tuviajeapp.co</a>, sus subdominios, aplicaciones móviles, plataformas digitales y demás canales virtuales gestionados por TUVIAJE AGENCIA DE VIAJES Y OPERADOR TURÍSTICO S.A.S., en su calidad de responsable del tratamiento.
          </p>
          <p>
            Esta política aplica a usuarios digitales (en adelante, “USUARIOS”), así como a proveedores, empleados, aliados comerciales y demás titulares cuyos datos personales sean tratados por TUVIAJE.
          </p>

          <h6>3. DEFINICIONES</h6>
          <ul>
            <li><strong>Dato personal:</strong> Cualquier información vinculada o que pueda asociarse a una o varias personas naturales determinadas o determinables.</li>
            <li><strong>Tratamiento:</strong> Cualquier operación sobre datos personales, como recolección, almacenamiento, uso, circulación o supresión.</li>
            <li><strong>Titular:</strong> Persona natural cuyos datos personales son objeto de tratamiento.</li>
            <li><strong>Autorización:</strong> Consentimiento previo, expreso e informado del titular para el tratamiento de sus datos.</li>
            <li><strong>Responsable del tratamiento:</strong> Persona jurídica que decide sobre la base de datos y/o el tratamiento.</li>
          </ul>

          <h6>4. DATOS QUE SE RECOLECTAN</h6>
          <p>A través de TUVIAJEAPP.CO, TUVIAJE puede recolectar datos como:</p>
          <ul>
            <li>Identificación: nombre, apellidos, tipo y número de documento.</li>
            <li>Contacto: correo electrónico, teléfono, dirección.</li>
            <li>Datos de pago y facturación: información de tarjetas, cuentas bancarias, historial de pagos (cuando aplique).</li>
            <li>Datos de viaje: destinos, fechas, preferencias, acompañantes.</li>
            <li>Datos técnicos y de navegación: dirección IP, ubicación, cookies, tipo de navegador, sistema operativo, entre otros.</li>
          </ul>

          <h6>5. FINALIDADES DEL TRATAMIENTO</h6>
          <p>Los datos personales serán tratados para las siguientes finalidades:</p>
          <ol>
            <li>Prestación de servicios turísticos, reservas, pagos y operación logística.</li>
            <li>Gestión de relaciones contractuales y comerciales con los usuarios digitales.</li>
            <li>Atención de solicitudes, quejas, reclamos o sugerencias.</li>
            <li>Envío de información sobre promociones, planes, destinos, eventos y actualizaciones de la plataforma.</li>
            <li>Cumplimiento de obligaciones legales, contables, tributarias y administrativas.</li>
            <li>Validación de identidad, prevención de fraudes y garantía de seguridad digital.</li>
            <li>Segmentación de usuarios, análisis estadístico, estudios de mercado y mejoras de experiencia.</li>
            <li>Gestión de fidelización, encuestas de satisfacción y programas de lealtad.</li>
          </ol>

          <h6>6. DERECHOS DEL TITULAR</h6>
          <p>De conformidad con el artículo 8 de la Ley 1581 de 2012, el titular tiene los siguientes derechos:</p>
          <ul>
            <li>Conocer, actualizar y rectificar sus datos personales.</li>
            <li>Solicitar prueba de la autorización otorgada.</li>
            <li>Ser informado sobre el uso que se ha dado a sus datos.</li>
            <li>Presentar quejas ante la SIC cuando considere que se ha vulnerado la ley.</li>
            <li>Revocar la autorización y/o solicitar la supresión de sus datos, cuando no exista un deber legal o contractual que lo impida.</li>
            <li>Acceder en forma gratuita a sus datos personales.</li>
          </ul>

          <h6>7. MECANISMOS DE AUTORIZACIÓN</h6>
          <p>
            TUVIAJE obtiene la autorización del titular mediante medios físicos, electrónicos o verbales, o a través de conductas inequívocas (por ejemplo, el registro en la plataforma, aceptación de términos en línea o uso del sitio).
          </p>

          <h6>8. COOKIES Y TECNOLOGÍAS DE SEGUIMIENTO</h6>
          <p>El sitio web TUVIAJEAPP.CO utiliza cookies y tecnologías similares para:</p>
          <ul>
            <li>Identificar la sesión del usuario.</li>
            <li>Recordar preferencias.</li>
            <li>Analizar comportamiento de navegación.</li>
            <li>Optimizar campañas de marketing y experiencias personalizadas.</li>
          </ul>
          <p>
            El usuario puede configurar su navegador para desactivar las cookies, aunque esto podría afectar el funcionamiento de algunas funcionalidades del sitio.
          </p>

          <h6>9. TRANSFERENCIA Y TRANSMISIÓN DE DATOS</h6>
          <p>TUVIAJE podrá compartir los datos personales con:</p>
          <ul>
            <li>Proveedores de servicios tecnológicos (cloud, CRM, hosting).</li>
            <li>Pasarelas de pago y entidades financieras.</li>
            <li>Agencias, operadores o terceros aliados que intervengan en la cadena de prestación del servicio turístico.</li>
            <li>Autoridades administrativas o judiciales, en cumplimiento de requerimientos legales.</li>
          </ul>
          <p>
            Toda transmisión nacional o internacional de datos se realizará bajo contratos de confidencialidad y con garantías de protección adecuadas.
          </p>

          <h6>10. MEDIDAS DE SEGURIDAD</h6>
          <p>TUVIAJE adopta medidas administrativas, técnicas, legales y contractuales para garantizar la protección de los datos personales, incluyendo:</p>
          <ul>
            <li>Cifrado de información sensible.</li>
            <li>Políticas de control de acceso.</li>
            <li>Certificados SSL.</li>
            <li>Copias de seguridad y firewalls.</li>
            <li>Autenticación segura para el acceso a plataformas.</li>
          </ul>

          <h6>11. CONSERVACIÓN DE LA INFORMACIÓN</h6>
          <p>
            Los datos serán conservados por el tiempo que sea necesario para cumplir con las finalidades descritas o las obligaciones legales derivadas. Cuando ya no sea necesario su tratamiento, los datos serán eliminados o anonimizados conforme a la ley.
          </p>

          <h6>12. PROCEDIMIENTO PARA EL EJERCICIO DE DERECHOS</h6>
          <p>
            El titular podrá ejercer sus derechos mediante solicitud escrita o por medios electrónicos a los siguientes canales:
          </p>
          <ul>
            <li>Correo electrónico: <a href="mailto:protecciondedatos@tuviajeapp.co">protecciondedatos@tuviajeapp.co</a></li>
            <li>Dirección física: carrera 83c#17-52</li>
            <li>Teléfono: +57 3207203420</li>
          </ul>
          <p>Plazos de atención:</p>
          <ul>
            <li>Consultas: 10 días hábiles</li>
            <li>Reclamos: 15 días hábiles</li>
          </ul>

          <h6>13. CAMBIOS EN LA POLÍTICA</h6>
          <p>
            TUVIAJE podrá modificar esta Política en cualquier momento. Las actualizaciones serán publicadas en el sitio web <a href="https://www.tuviajeapp.co">www.tuviajeapp.co</a> y se informará a los usuarios cuando la ley así lo exija.
          </p>

          <h6>14. LEGISLACIÓN APLICABLE</h6>
          <p>
            Esta política se rige por la Constitución Política de Colombia, la Ley 1581 de 2012, el Decreto 1377 de 2013, la jurisprudencia y demás normas que las modifiquen, adicionen o reglamenten.
          </p>


        </div>




      </div>
    </div>
  );
};
